import { render, staticRenderFns } from "./ArqPreviusPage.vue?vue&type=template&id=213f5e10&"
import script from "./ArqPreviusPage.vue?vue&type=script&lang=js&"
export * from "./ArqPreviusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports